export default function HeadingMedium({ children }) {
  return (<h2 className="text-2xl pb-2 font-medium tracking-tight font-[Outfit]">{children}</h2>)
}
